import { SAVE_PORTAL_CONFIGURATION } from './savePortalConfiguration';
import { GET_PORTAL_CONFIGURATIONS } from './getPortalConfigurations';

export const portalConfigurationApi = {
  saveConfig: SAVE_PORTAL_CONFIGURATION,
  fetchConfig: GET_PORTAL_CONFIGURATIONS,
};

export * from './usePortalConfiguration';
